import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the record table transaction report view.
 * @extends JetView
 */
export default class recordTableTransReportView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function

        // Window for filter details
        const filterDetails = webix.ui({
            view: 'window',
            move: true,
            id: 'filterDetails',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    {
                        view: 'label',
                        label: _('Historial de Transacciones'), // Transaction history label
                        align: 'center',
                    },
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide window on click
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'datatable', // Data table for displaying transaction details
                id: 'dtDetails',
                css: 'webix_header_border webix_data_border webix_footer_border',
                select: true,
                columns: [
                    {
                        id: 'Id',
                        header: _('Ticket Det Id'), // Ticket detail ID header
                        width: 100,
                        sort: 'int', // Sorting type
                    },
                    { id: 'Type', header: _('Tipo'), width: 100, sort: 'int' }, // Type header
                    {
                        id: 'TicketId',
                        header: _('Ticket ID'), // Ticket ID header
                        width: 100,
                        sort: 'int',
                    },
                    { id: 'Date', header: _('Fecha'), width: 150, sort: 'int' }, // Date header
                    {
                        id: 'TransactionId',
                        header: _('Transacción Id'), // Transaction ID header
                        width: 100,
                        sort: 'int',
                    },
                    {
                        id: 'Amount',
                        header: _('Monto'), // Amount header
                        width: 100,
                        format: webix.i18n.priceFormat, // Formatting for price
                        exportType: 'number',
                        sort: 'int',
                    },
                ],
            },
        });

        // Main data table configuration
        return {
            view: 'datatable',
            css: 'webix_header_border webix_data_border webix_footer_border',
            select: true,
            columns: [
                {
                    id: 'Id',
                    header: _('Ticket Det Id'), // Ticket detail ID header
                    width: 100,
                    sort: 'int',
                },
                { id: 'Type', header: _('Tipo'), width: 100, sort: 'int' }, // Type header
                {
                    id: 'TicketId',
                    header: _('Ticket ID'), // Ticket ID header
                    width: 100,
                    sort: 'int',
                },
                { id: 'Date', header: _('Fecha'), width: 150, sort: 'int' }, // Date header
                {
                    id: 'TransactionId',
                    header: _('Transacción Id'), // Transaction ID header
                    width: 100,
                    sort: 'int',
                },
                {
                    id: 'Amount',
                    header: _('Monto'), // Amount header
                    width: 100,
                    format: webix.i18n.priceFormat, // Formatting for price
                    exportType: 'number',
                    sort: 'int',
                },
            ],
            loadahead: 0, // Load ahead configuration
            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
            pager: 'pagerA', // Pager ID
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The data table grid instance.
     */
    init(grid) {
        var url = devConfig.geturlApi() + 'null/Report/GetBetHistoryTransactions'; // API URL for fetching transaction history

        // Event listener for user ID changes
        this.on(this.app, 'user:id', (idUser) => {
            grid.clearAll(); // Clear existing grid data
            grid.load(url + '?id=' + idUser); // Load new data based on user ID
            $$('dtDetails').clearAll(); // Clear details data table
            $$('dtDetails').load(url + '?id=' + idUser); // Load details data based on user ID
        });
    }
}

// FILE DOCUMENTED
